import { render, staticRenderFns } from "./AnagraficaComponent.vue?vue&type=template&id=15365dde&"
import script from "./AnagraficaComponent.vue?vue&type=script&lang=js&"
export * from "./AnagraficaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports